import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetSummary = createAsyncThunk(
  "GetSummary",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Summary/GetSummary", param);

      const data = response.data.result;
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const Summary = createSlice({
  name: "Summary",
  initialState: {
    Summary: {},
    loadingSummary: false,
    errorSummary: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetSummary.pending, (state, action) => {
        state.loadingWorkFlow = true;
        state.Summary = action.payload;
        state.errorSummary = null;
      })
      .addCase(GetSummary.fulfilled, (state, action) => {
        state.loadingSummary = false;
        state.Summary = action.payload;
      })
      .addCase(GetSummary.rejected, (state, action) => {
        state.loadingSummary = false;
        state.errorSummary = action.payload;
      });
  },
});
export default Summary.reducer;
